// config.js
const config = {
  apiUrl: 'https://keruencargo.kz:3001',  
  // apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',
    nameCargo: 'KERUEN CARGO',
    vapidPublicKey: 'BJtBjK8np_BeUhsJubD6JLvmmGSDGPWlbOC_wqrY6Y7Qnsv4NorYvAAdV3-so5slfk1aru_j9MehVv3ggqmAm90'
  };

export default config;
